import React, { createContext, useContext, useState } from "react";

// Création du contexte
export const RefreshContext = createContext();

// Hook pour y accéder facilement dans tes composants
export function useRefresh() {
  return useContext(RefreshContext);
}

// Provider à utiliser autour de ton App
export function RefreshProvider({ children }) {
  const [refreshCount, setRefreshCount] = useState(0);

  // Cette fonction "triggere" un refresh global
  const triggerRefresh = () => setRefreshCount((c) => c + 1);

  return (
    <RefreshContext.Provider value={{ refreshCount, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
}